import { render, staticRenderFns } from "./EditSocialMediaLinks.vue?vue&type=template&id=58d7f59e&scoped=true&"
import script from "./EditSocialMediaLinks.vue?vue&type=script&lang=ts&"
export * from "./EditSocialMediaLinks.vue?vue&type=script&lang=ts&"
import style0 from "./EditSocialMediaLinks.vue?vue&type=style&index=0&id=58d7f59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d7f59e",
  null
  
)

export default component.exports